"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.common.help': 'Common avatars are visible to all users but cannot be edited by non-super-admins',
};
